import { gql } from '@apollo/client'

export default gql`
  mutation ADD_TAG_TO_ARTICLE($articleId: Int!, $tagId:Int!) {
    insertArticleTag: insert_wp_posts_x_tags(objects: [{wp_post_id: $articleId, tag_id: $tagId}]) {
      returning {
        id
        tag {
          name
        }
      }
    }
  }
`
